import type { ProductId } from "../types";

interface ProductInterfaceProps {
  type?: ProductId;
}

export function ProductInterface({ type = "bid" }: ProductInterfaceProps) {
  if (type === "proposal") {
    return (
      <div className="product-ui product-ui--proposal" aria-label="标书智作响应框架">
        <div className="product-ui__top">
          <span>响应框架</span>
          <span className="ui-note">智能标书工作台</span>
        </div>
        <div className="proposal-layout">
          <div className="proposal-nav">
            <span>01　项目概览</span>
            <span>02　资格条件</span>
            <span className="proposal-nav__active">03　评分标准</span>
            <span>04　服务方案</span>
            <span>05　投标结构</span>
          </div>
          <div className="proposal-doc">
            <div className="doc-kicker">评分标准 · 技术部分</div>
            <div className="score-sheet__head">
              <h4>项目团队与实施能力</h4>
              <span>20 分</span>
            </div>
            <div className="score-sheet">
              <div className="score-sheet__labels">
                <span>评分项与响应要求</span>
                <b>分值</b>
              </div>
              <div>
                <span>
                  <strong>项目负责人经验</strong>
                  <small>同类项目经验与资格证明</small>
                </span>
                <b>8</b>
              </div>
              <div>
                <span>
                  <strong>专业团队配置</strong>
                  <small>人员分工、资质与投入计划</small>
                </span>
                <b>7</b>
              </div>
              <div>
                <span>
                  <strong>实施保障机制</strong>
                  <small>进度、质量与沟通安排</small>
                </span>
                <b>5</b>
              </div>
            </div>
            <div className="doc-highlight">
              <span>已定位评分依据</span>
              <strong>4 条</strong>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="product-ui product-ui--bid" aria-label="智能标讯专业服务检索">
      <div className="product-ui__top">
        <span>专业服务招标机会</span>
        <span className="ui-note">智能标讯 · 项目检索</span>
      </div>
      <div className="ui-filter-row">
        <span className="ui-filter ui-filter--active">全部类型</span>
        <span className="ui-filter">审计</span>
        <span className="ui-filter">税务</span>
        <span className="ui-filter">评估 / 咨询</span>
      </div>
      <div className="tender-item">
        <div className="tender-date">
          <strong>18</strong>
          <span>八月</span>
        </div>
        <div className="tender-copy">
          <span className="tender-tag">审计服务</span>
          <h4>年度财务报表审计服务项目</h4>
          <p>华东地区 · 8 月 18 日截止 · 预算以公告为准</p>
        </div>
        <span className="tender-arrow">→</span>
      </div>
      <div className="tender-item">
        <div className="tender-date">
          <strong>21</strong>
          <span>八月</span>
        </div>
        <div className="tender-copy">
          <span className="tender-tag">咨询服务</span>
          <h4>专项咨询服务采购项目</h4>
          <p>华南地区 · 8 月 21 日截止 · 预算以公告为准</p>
        </div>
        <span className="tender-arrow">→</span>
      </div>
      <div className="tender-item tender-item--muted">
        <div className="tender-date">
          <strong>25</strong>
          <span>八月</span>
        </div>
        <div className="tender-copy">
          <span className="tender-tag">税务服务</span>
          <h4>税务合规与专项咨询服务项目</h4>
          <p>华北地区 · 8 月 25 日截止 · 预算以公告为准</p>
        </div>
        <span className="tender-arrow">→</span>
      </div>
    </div>
  );
}
